import React from 'react'
import axios from "axios";
import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { DropdownTopbarItemToggler } from "../../../Utils/_partials/dropdowns";
import { Tracker } from "../../util/analytics";
import { callAPi } from "../../util/callApi";
import { API_ENDPOINTS, API_ENDPOINT_BASE_URL } from "../../util/constants";
import { getUser } from "../../util/helpers";
import { actions as authActions } from "../Auth/_redux/authRedux";
import { getAgentNumbers, hasPhone, hasSIP } from "./api";
import { setSnackbar } from '../../../redux/snackbar';
import * as constants from "../Ticker/constants";
import { MultiTabAlertDialog } from '../../util/MultiTabCheck';
import useTabManagement from '../../util/useTabManagement';

export const PhoneSelect = (props) => {
  const dispatch = useDispatch();

  const phone_switch_state = useSelector((state) => {
    return state.ticker.phone_switch_state;
  });

  const sip_connected = useSelector((state) => {
    return state.ticker.sip_connected;
  });

  const is_mpls = useSelector((state) => {
    return state.auth.is_mpls;
  });

  const sip_tried = useSelector((store) => {
    return store.ticker.sip_tried;
  });

  const sip_retry = useSelector((state) => {
    return state.ticker.sip_retry;
  });

  const session_agent = useSelector((state) => {
    return state.ticker.phone_switch_agent;
  });

  const { extra_data } = useSelector(({ auth }) => ({
    extra_data: auth.extra_data,
  }));

  const isDuplicatedTab = useSelector(state => state.auth.is_duplicated_tab);
  const sipUserSession = useSelector(state => state.ticker.sip_user);

  const [is_menu_enabled, setMenuEnabled] = useState(false);
  const [is_phone_enabled, setHasPhone] = useState(false);

  const [openMultiTabDialog, setOpenMultiTabDialog] = useState(false);

  useEffect(() => {
    if (is_mpls && session_agent) {
      if (hasPhone(session_agent)) {
        setHasPhone(true);
      }
      if (hasSIP(session_agent)) {
        setMenuEnabled(true);
      }
    }
    return () => {};
  }, [session_agent, is_mpls]);

  const retrySIPConnect = () => {
    Tracker.event(
      "Calling Mode",
      "Click",
      "Retry WebRTC/Softphone",
      "Retry",
      getUser()
    );

    dispatch({
      type: "onSetTickerState",
      payload: { sip_tried: false, sip_retry: sip_retry + 1, call_state: constants.CALL_STATES.CALL_HANGUP },
    });
    dispatch({ type: "Close", payload: {} });
    dispatch({ type: "onCallEvent", payload: {} });
  };

  const { makeCurrentTabPrimary } = useTabManagement(dispatch, setOpenMultiTabDialog);

  const togglePhone = async (toggle_to, tag) => {
    if (tag) {
      Tracker.event(
        "Calling Mode",
        "Save",
        "Select Calling Mode",
        tag,
        getUser()
      );
    }

    const url =
      API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/sip_phone_toggle/";
      try{
        const response = await axios.put(url, { toggle_to: toggle_to });
        if (response.status === 200) {
          dispatch(setSnackbar(true, "success", response.data.message));
          let requestURL = API_ENDPOINTS.userDetail;
          try {
            let response = await callAPi(requestURL, "GET");
            if (response.status === 200) {
              dispatch(authActions.userDetailSuccessRefreshed(response.data));
              const response2 = await getAgentNumbers(dispatch);
              dispatch({
                type: "onSetTickerState",
                payload: { phone_switch_state: toggle_to },
              });
            }
          } catch (error) {}
        }
        else{
          dispatch(setSnackbar(true, "error", response?.data?.message));
        }
      }  catch (error) {
        if (error.response) {
          dispatch(setSnackbar(true, "error", "Request failed, please refresh & try again."));
        } 
   
    }
  };

  useEffect(() => {
    if (isDuplicatedTab) {
      setOpenMultiTabDialog(true);
      if (sipUserSession && sipUserSession?.isConnected()) {
        sipUserSession?.disconnect();
      }
      dispatch({ type: "Close", payload: {} });
    }
  }, [isDuplicatedTab, sipUserSession])

  const selectSipNavItem = (
    <>
      <div className="navi-link d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div className="navi-icon mr-2">
            {phone_switch_state === "sip" && sip_connected && (
              <img
                alt=""
                className=""
                src={toAbsoluteUrl("/media/sr/icons/call/web-selected.svg")}
              />
            )}
            {phone_switch_state === "sip" && !sip_connected && sip_tried && (
              <img
                alt=""
                className=""
                src={toAbsoluteUrl("/media/sr/icons/webrtc-lost.svg")}
              />
            )}

            {(phone_switch_state !== "sip" ||
              (phone_switch_state === "sip" &&
                !sip_connected &&
                !sip_tried)) && (
              <img
                alt=""
                className=""
                src={toAbsoluteUrl("/media/sr/icons/call/web-notselected.svg")}
              />
            )}
          </div>
          <div className="navi-text">
            <div className="font-weight-bold">WebRTC/SoftPhone</div>
          </div>
        </div>
        <div>
          {phone_switch_state === "sip" && !sip_connected && sip_tried && (
            <div className="">
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  retrySIPConnect();
                }}
                className="retry-opt"
              >
                {" "}
                <img
                  alt=""
                  className="retry-icon"
                  src={toAbsoluteUrl("/media/sr/icons/refresh-icon.svg")}
                />{" "}
                RETRY
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="text-center">
        {phone_switch_state === "sip" && !sip_connected && sip_tried && (
          <p className="error">
            Connection lost.
            <br />
            Please retry to re-establish connection. If the issue persists,
            reach out to the administrator.
          </p>
        )}
      </div>
    </>
  );

  const selectPhoneNavItem = (
    <>
      {is_phone_enabled && (
        <div className="navi-link">
          <div className="navi-icon mr-2">
            {phone_switch_state === "sip" && (
              <img
                alt=""
                className=""
                src={toAbsoluteUrl(
                  "/media/sr/icons/call/phone-notselected.svg"
                )}
              />
            )}
            {phone_switch_state !== "sip" && (
              <img
                alt=""
                className=""
                src={toAbsoluteUrl("/media/sr/icons/call/phone-selected.svg")}
              />
            )}
          </div>
          <div className="navi-text">
            <div className="font-weight-bold">Phone</div>
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      {isDuplicatedTab &&
        <div className="mr-4">
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              setOpenMultiTabDialog(true);
            }}
            className="retry-opt multi-tab-retry"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              color: 'inherit',
              padding: 1.5,
              border: '1px solid #ccd6e3',
              borderRadius: 5
            }}
          >
            {" "}
            <img
              alt=""
              className="retry-icon mr-1"
              src={toAbsoluteUrl("/media/sr/icons/refresh-icon.svg")}
              style={{ height: 20 }}
            />{" "}
            <span className='mr-2' style={{ textAlign: 'center', fontSize: 'smaller' }}>Make Primary</span>
          </a>
        </div>}
      <MultiTabAlertDialog showModal={openMultiTabDialog} toggleModal={setOpenMultiTabDialog} handleUseThisTab={makeCurrentTabPrimary} />
      {is_menu_enabled && extra_data && extra_data.is_device_enabled ? (
        <>
          {phone_switch_state === "sip" && !sip_connected && sip_tried && !isDuplicatedTab && (
            <span
              className="text-danger"
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "5px",
                justifyContent: "center",
              }}
            >
              Connection Lost
            </span>
          )}
          <Dropdown drop="down" className="sel-call-mode-sec" alignRight style={isDuplicatedTab ? { pointerEvents: 'none', opacity: .7 } : {}}>
            <Dropdown.Toggle
              as={DropdownTopbarItemToggler}
              id="dropdown-phone-toggle"
            >
              <div
                className={
                  "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg sel-call-mode-btn mr-4 " +
                  (phone_switch_state === "sip" && !sip_connected && sip_tried && !isDuplicatedTab
                    ? " border-danger"
                    : "")
                }
              >
                <span className="">
                  {phone_switch_state === "sip" && (
                    <span className="">
                      {isDuplicatedTab &&
                        <img
                          alt=""
                          className="sel-mode-icon"
                          src={toAbsoluteUrl(
                            "/media/sr/icons/call/web-notselected.svg"
                          )}
                        />
                      }
                      {!isDuplicatedTab &&
                        <>
                          {sip_connected && (
                            <img
                              alt=""
                              className="sel-mode-icon"
                              src={toAbsoluteUrl(
                                "/media/sr/icons/call/web-active.svg"
                              )}
                            />
                          )}
                          {!sip_connected && sip_tried && (
                            <img
                              alt=""
                              className="sel-mode-icon"
                              src={toAbsoluteUrl("/media/sr/icons/webrtc-lost.svg")}
                            />
                          )}
                          {!sip_connected && !sip_tried && (
                            <img
                              alt=""
                              className="sel-mode-icon"
                              src={toAbsoluteUrl(
                                "/media/sr/icons/call/web-notselected.svg"
                              )}
                            />
                          )}
                        </>}
                    </span>
                  )}

                  {phone_switch_state !== "sip" && (
                    <>
                      {isDuplicatedTab ?
                        <img
                          alt=""
                          className="sel-mode-icon"
                          src={toAbsoluteUrl(
                            "/media/sr/icons/call/phone-notselected.svg"
                          )}
                        />
                        :
                        <span className="">
                          <img
                            alt=""
                            className="sel-mode-icon"
                            src={toAbsoluteUrl(
                              "/media/sr/icons/call/phone-active.svg"
                            )}
                          />
                        </span>
                      }
                    </>
                  )}
                </span>
                <span>
                  <img
                    alt=""
                    src={toAbsoluteUrl("/media/sr/icons/angle-up.svg")}
                    className="show-profile-icon"
                  />
                </span>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround sel-call-mode-dd">
              <div className="navi navi-spacer-x-0 pt-5">
                <div className="sel-mode-head px-6">Select Calling Mode</div>
                {phone_switch_state === "sip" && (
                  <a
                    href="/#"
                    className="navi-item px-6"
                    onClick={(e) => {
                      e.preventDefault();
                      togglePhone("phone", "Phone");
                    }}
                  >
                    {selectPhoneNavItem}
                  </a>
                )}
                {phone_switch_state !== "sip" && (
                  <div className="navi-item px-6">{selectPhoneNavItem}</div>
                )}

                {phone_switch_state !== "sip" && (
                  <a
                    href="/#"
                    className="navi-item px-6"
                    onClick={(e) => {
                      e.preventDefault();
                      togglePhone("sip", "WebRTC/Softphone");
                    }}
                  >
                    {selectSipNavItem}
                  </a>
                )}
                {phone_switch_state === "sip" && (
                  <div className="navi-item px-6">{selectSipNavItem}</div>
                )}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </>
      ) : (
        ""
      )}
    </>
  );
};
